import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { notFoundEntrypoint } from '@atlassian/jira-spa-apps-error-pages-not-found/entrypoint.tsx';

export const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
	topNavigationMenuId: MENU_ID.HOME,
});
